/** Validated Mexican RFC (Registro Federal de Contribuyentes) value object */
export type Rfc = Readonly<string>;

/** Mexican RFC regex: 3-4 uppercase letters/Ñ/&, 6 digits (YYMMDD), 3 alphanumeric homoclave */
export const RFC_REGEX = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;

/**
 * Creates a validated Rfc value object.
 * Normalizes input to uppercase and trims whitespace.
 *
 * @param raw - Raw RFC string
 * @returns Validated Rfc
 * @throws Error if RFC is empty or does not match the Mexican RFC format
 */
export const createRfc = (raw: string): Rfc => {
  const normalized = raw.trim().toUpperCase();
  if (!normalized) {
    throw new Error('RFC is required');
  }
  if (!RFC_REGEX.test(normalized)) {
    throw new Error('RFC format is invalid');
  }
  return normalized as Rfc;
};
